import { render, staticRenderFns } from "./SurveyContact.vue?vue&type=template&id=10452957&scoped=true&"
import script from "./SurveyContact.vue?vue&type=script&lang=js&"
export * from "./SurveyContact.vue?vue&type=script&lang=js&"
import style0 from "./SurveyContact.vue?vue&type=style&index=0&id=10452957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10452957",
  null
  
)

export default component.exports